import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { ModalComponent, DynamicFormComponent, PopUpService } from '../../core';
import { Document } from '../document';
import { DocumentsService } from '../documents.service';
import { DocumentsQuestionsService } from '../documents-questions.service';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'lms-document-detail',
  templateUrl: './document-detail.component.html',
  styleUrls: ['./document-detail.component.scss']
})
export class DocumentDetailComponent implements OnInit {
  public document: Document;
  public modal: ModalComponent;

  public questionsListId = 'QUESTION_LIST';

  public filters: Map<string, string>;

  public documentsSortingFields = [
    { field: 'name', label: 'documents.sortableFields.name' },
    { field: 'email', label: 'documents.sortableFields.email' }
  ];

  public MAX_QUESTIONS = 5;
  public disableNewQuestion = false;
  public questions: any[];
  @ViewChild(DynamicFormComponent, { static: false }) public dynamicForm: DynamicFormComponent;

  constructor(
    public documentsService: DocumentsService,
    public route: ActivatedRoute,
    public location: Location,
    public router: Router,
    public popupService: PopUpService,
    public documentsQuestions: DocumentsQuestionsService
  ) {}

  ngOnInit() {
    this.route.paramMap
      .pipe(switchMap((params: ParamMap) => this.documentsService.getDocument(params.get('id'))))
      .subscribe((document) => {
        this.disableNewQuestion = document.questions && document.questions.length >= this.MAX_QUESTIONS;
        this.filters = new Map<string, string>().set('documentId', document.id);
        this.document = document;
        this.questions = this.documentsQuestions.getQuestions(this.document, this.document.clientId);
      });
  }

  verifyList(newList) {
    this.disableNewQuestion = newList && newList.length >= this.MAX_QUESTIONS;
  }

  goBack(): void {
    this.router.navigate(['/customizations']);
  }

  updateDocument(updatedData: Object) {
    const updateddocument: Document = Object.assign({}, this.document, updatedData);
    this.documentsService
      .update(updateddocument)
      .then((document) => {
        this.endSubmit(null);
      })
      .catch((err) => {
        this.endSubmit(err);
      });
  }

  endSubmit(value) {
    this.dynamicForm.submitted(value);
  }
}
